import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './api';
import type { SharedBlock } from '../types/api';

export const SHARED_BLOCKS_KEY = ['shared-blocks'] as const;

/**
 * The tenant's shared blocks (K4). One list query shared by the picker, the
 * live preview and the admin page. A failed load simply gives an empty list:
 * the preview then shows nothing for a shared block and the server still
 * expands it correctly when the mail is prepared.
 */
export function useSharedBlocks() {
  const query = useQuery({
    queryKey: SHARED_BLOCKS_KEY,
    queryFn: () => apiFetch<{ items: SharedBlock[] }>('/shared-blocks'),
    staleTime: 30_000,
  });
  return { ...query, blocks: query.data?.items ?? [] };
}

/** id -> html, for `expandSharedBlocks` in the live previews. */
export function sharedBlockMap(blocks: readonly SharedBlock[]): Map<string, string> {
  return new Map(blocks.map((b) => [b.id, b.html]));
}
